<div
  class="myre-multi-select"
  [class.draggable]="draggable"
  [cdkDropListData]="items"
  (cdkDropListDropped)="moveItem($event)"
  cdkDropList
>
  @for (item of items; track item.value ?? $index; let index = $index) {
    <div
      [cdkDragDisabled]="!isDraggable(item)"
      class="myre-multi-select__item"
      [class.disabled]="!isDraggable(item)"
      [cdkDragData]="item"
      cdkDrag
    >
      <mat-checkbox
        [disabled]="item.disabled || readonly"
        [class.disabled]="disabled"
        [class.readonly]="readonly"
        [checked]="isChecked(item)"
        [color]="color"
        (change)="onChange($event.checked, item.value, index)"
        >{{ item.label }}
      </mat-checkbox>
    </div>
  }
</div>
